module.exports = __webpack_public_path__ + "Montserrat-Regular.44d9afcccb14849b7e16.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Montserrat-Regular.ttf
// module id = 278
// module chunks = 2